import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.css']
})
export class InfoDialogComponent {

  constructor(public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  confirm(): void {
    // if(this.data.canClose) this.dialogRef.close();
  }
}

@Component({
  selector: 'alert-dialog',
  template: `
      <div class="container">
      <h3 mat-dialog-title>Alerty cenowe dla SKU: {{ data.sku }}</h3>
      <div class="">
        <ul style="padding-left: 20px;">
          <li *ngFor="let alert of data.text.Message">{{ alert }}</li>
        </ul>
      </div>
     <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="1" (click)="confirm()">Zamknij</button>
      </div>
    </div>

    <style>
      .conf-dialog-caption {
        font-size: 13px;
      }
    </style>
  `
})
export class AlertsInfoDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<AlertsInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {text: {Message: string[]}, sku: string}
  ) { }

  confirm(): void {
    this.dialogRef.close();
  }
}
